/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Layout { 
    page?: Layout.PageEnum;
    'left-pos'?: number;
    'top-pos'?: number;
}
export namespace Layout {
    export const PageEnum = {
        First: 'FIRST',
        Penultimate: 'PENULTIMATE',
        Ultimate: 'ULTIMATE'
    } as const;
    export type PageEnum = typeof PageEnum[keyof typeof PageEnum];
}


